function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m28.7,5.26284l-30,0",
  id: "svg_1",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  fill: "#1B75BB",
  height: 9.4,
  id: "svg_3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  width: 13.000002,
  x: 1.65,
  y: 4.2
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m1.65,4.238934l13.049999,0.081474l-2.284464,-2.720408l-8.452516,0l-2.313019,2.638934z",
  fill: "#1B75BB",
  id: "svg_6",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "m3.622223,3.722223l8.877777,-0.022222l-1.028697,-1.46l-6.524198,0.005162l-1.097106,1.454839l-0.227777,0.022222z",
  fill: "#ffffff",
  id: "svg_7",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "m6.981011,5.708468l2.233796,0.060828l0.000328,2.936886l1.790573,0.078865l-2.820227,2.707389l-2.791638,-2.784846l1.558117,-0.000704l0.029049,-2.998417l0.000001,-0.000001z",
  fill: "#ffffff",
  id: "svg_8",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  transform: "rotate(-0.438723 8.19978 8.60045)"
});

function SvgArchive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchive);
export default __webpack_public_path__ + "static/media/archive.66096b75.svg";
export { ForwardRef as ReactComponent };